<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
import VeiBanBridge from "@/utils/bridge";
export default {
  name: "App",
  components: {},
  data() {
    return {
      // user: {
      //   userName: "马超",
      //   companyName: "深圳前海优管信息技术测试公司",
      //   phone: "15013734208",
      //   userIcon:
      //     "https://qiniu.veiban.com/D40F07E5435063F82BCB3E6B34D7496F.gif",
      //   tenantId: "1586979014478311425",
      //   newToken:
      //     "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyX2tleSI6Ijg1ZDA1ZTZiLWY0NzAtNGUzMy04NzNlLWJkOGZiYjc2ZDNhNSIsInVzZXJfaWQiOjE2MywidXNlcm5hbWUiOiIxNTAxMzczNDIwOCJ9.xsyfuhH2Hd4U9QHgWtUl6dqcWgkv6iu4saq84J_yV5OZYkmiQaNj3neQKO0uS5mVnZUgaLRnLud-DLG5BhPaqw",
      //   token:
      //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbktleSI6IlgtMjE4ZDEwNWY0ZjY4NDAxZWIxOTI2YjZmM2RjZTA2NWMtN2JjNTY0ZDAzZjVlNGFmMWE5NGZhYTg2N2JhZDlmMzgiLCJleHBpcmVUaW1lc3RhbXAiOiIxNzMzMzYxMjM5Mzg1IiwicGhvbmUiOiIxNTAxMzczNDIwOCIsInJlZnJlc2hUaW1lc3RhbXAiOiIxNzE3NTkzMjM5Mzg1IiwiZXhwIjoxNzMzMzYxMjM5LCJ1c2VySWQiOiIyMThkMTA1ZjRmNjg0MDFlYjE5MjZiNmYzZGNlMDY1YyIsImFjY2Vzc1RpbWVzdGFtcCI6IjE3MDE4MjUyMzkzODUifQ.zpASbmPsQ_iD0bA2NxtZWdqIbvSsYLrSQXFyC2c9XrE",
      //   companyId: "cfe05dd2cedf4dd1ad9475d32838eaf9",
      // },
    };
  },
  async created() {
    // localStorage.setItem("user", JSON.stringify(this.user));
    const querystring = require("querystring");
    const defaultData = querystring.parse(window.location.href.split("?")[1]);
    localStorage.setItem("token", defaultData.token);
    localStorage.setItem("companyId", defaultData.companyId);
    // localStorage.setItem('token', 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbktleSI6IlAtYjk1M2Y4MGZkNTMzNGZkODg1MWY3YzAwMmQzZGQ5MDItOWMzOTE1MTUxYWIzNDYyMmE2YmQ1ZjY0MTczOTgxMDUiLCJleHBpcmVUaW1lc3RhbXAiOiIxNjY5Nzk2NDc2NjIxIiwicGhvbmUiOiIxODMxMDY0MzExNyIsInJlZnJlc2hUaW1lc3RhbXAiOiIxNjg0MDkzMjQ3NjkzIiwiZXhwIjoxNjY5Nzk2NDc2LCJ1c2VySWQiOiJiOTUzZjgwZmQ1MzM0ZmQ4ODUxZjdjMDAyZDNkZDkwMiIsImFjY2Vzc1RpbWVzdGFtcCI6IjE2NjgzMjUyNDc2OTMifQ.quLINbqaXf7qe0uw7tGng1YAoSgS2uWbfKpJSDq_T7c')
    // localStorage.setItem('companyId', 'cfe05dd2cedf4dd1ad9475d32838eaf9')
    // http://localhost:8080/webviews/#/apply-form?modelId=6fa0d3b4c6168c1c1f79fbc37b48c2fc&companyId=cfe05dd2cedf4dd1ad9475d32838eaf9&name=22
    this.$store.commit("setInitialData", defaultData);
    this.oldHeight = document.documentElement.clientHeight;
    const user = (await VeiBanBridge.getUserInfo()) || {};
    console.log("[ user ] >", user);
    localStorage.setItem("user", JSON.stringify(user));
  },
  destroyed() {
    localStorage.removeItem("token");
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app {
  width: 100vw;
  /* background: #F2F2F2; */
  background: #f9f9f9;
  min-height: 100vh;
}
</style>
